import React from "react";
import { TypeAnimation } from "react-type-animation";
import MovingText from "react-moving-text";
import Button from "@mui/material/Button";
import { useMediaQuery, useTheme } from "@mui/material";
import banner from "../../assets/analytics/ai_banner_bg.png";
import { useNavigate } from "react-router-dom";

const Analytics_Banner = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <div>
      <div className="flex flex-col sm:flex-row justify-center w-full relative bg-gradient-to-r from-sky-50 via-blue-100 to-indigo-200">
        <div className="w-full sm:w-1/2 md:top-1 lg:top-24 py-10 flex flex-col justify-center">
          <div className="w-full text-lg sm:text-4xl px-10 font-bold poppins-bold text-[#333e49] text-center">
            <MovingText
              type="fadeInFromBottom"
              duration="1000ms"
              delay="0s"
              direction="normal"
              timing="ease"
              iteration="1"
              fillMode="none"
            >
              Unlocking The AI Solutions for Your Business Growth
            </MovingText>
          </div>
          <div className="w-full text-sm sm:text-lg  px-10 sm:leading-[5.5rem] font-notosans text-center text-[#0d6efd] font-semibold leading-5">
            <MovingText
              type="fadeInFromLeft"
              duration="1000ms"
              delay="0s"
              direction="normal"
              timing="ease"
              iteration="1"
              fillMode="none"
            >
              <TypeAnimation
                sequence={[
                  'We Experts in "Machine Learning"',
                  1000,
                  'We Experts in "Predictive Analytics"',
                  1000,
                  'We Experts in "Intelligent Automation"',
                  1000,
                ]}
                wrapper="span"
                speed={50}
                style={{ fontSize: "1em", display: "inline-block" }}
                repeat={Infinity}
              />
            </MovingText>
          </div>
          <p className="px-2 sm:px-10 text-center mt-3">
            <Button
              size={
                useMediaQuery(theme.breakpoints.down("sm")) ? "small" : "medium"
              }
              variant="contained"
              onClick={() => navigate("/contact")}
            >
              Free Consultation
            </Button>
          </p>
        </div>
        <div className="w-full sm:w-1/2 flex justify-center items-start sm:items-center relative sm:mt-2">
          {/* Soft blurred glow behind image to blend edges with section bg */}
          <div className="absolute w-[20rem] sm:w-[32rem] h-[20rem] sm:h-[32rem] bg-blue-50/60 rounded-full blur-3xl"></div>
          <img
            className="w-[15rem] sm:w-[30rem] animate-pulse relative z-10 mt:4 sm:mt-2 mb-2"
            src={banner}
          />
        </div>
      </div>
    </div>
  );
};

export default Analytics_Banner;